<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1" id="_idContainer000">
<p class="TITLE">Wisdom’s Feast</p>
<p class="SUBTITLE">An Invitation to Feminist Interpretation of the Scriptures</p>
<p class="AUTHOR">Barbara E. Reid, O.P.</p>
<p class="COMPANY">William B. Eerdmans Publishing Company<br/>Grand Rapids, Michigan</p>
<p class="COPYRIGHT">Wm. B. Eerdmans Publishing Co.<br/>2140 Oak Industrial Drive N.E., Grand Rapids, Michigan 49505 <br/><span class="url"><a href="http://www.eerdmans.com" target="_blank">www.eerdmans.com</a></span><span class="url CharOverride-1"><br/></span><br/>© 2016 Barbara E. Reid<br/>All rights reserved<br/>Published 2016<br/>Printed in the United States of America<br/><span class="scall">ISBN</span> 978-0-8028-7351-4</p>
<p class="LIBRARY">Library of Congress Cataloging-in-Publication Data</p>
<p class="CIP">Names: Reid, Barbara E., author.</p>
<p class="CIP">Title: Wisdom’s feast : an invitation to feminist interpretation of the scriptures / <br/>Barbara E. Reid, O.P.</p>
<p class="CIP">Description: Grand Rapids : Eerdmans Publishing Company, 2016. | <br/>Includes bibliographical references.</p>
<p class="CIP">Identifiers: LCCN 2016013134 | ISBN 9780802873514 (pbk. : alk. paper)<br/>eISBN 9781467445436 (ePub)<br/>eISBN 9781467444965 (Kindle)</p>
<p class="CIP">Subjects: LCSH: Bible—Feminist criticism. | Bible and feminism.</p>
<p class="CIP">Classification: LCC BS521.4 .R45 2016 | DDC 220.6082—dc23<br/>LC record available at <span class="url">https://lccn.loc.gov/2016013134</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Reid_Wisdoms_Feast.vue?31ba06e4